import { isPayLaterProduct, isSecuredInstallmentLoanProduct } from './productTypeHelpers';
const shouldEnableManagePaymentMethods = (productType, isManagePaymentMethodsEnabled) => {
    if (isPayLaterProduct(productType) ||
        isSecuredInstallmentLoanProduct(productType)) {
        return false;
    }
    return isManagePaymentMethodsEnabled;
};
export default shouldEnableManagePaymentMethods;
